import React from "react";
import { Checkbox, RadioButtons, RadioButton, Select } from "@veneer/core";

interface QuestionOptionsProps {
  question: any;
  handleChangeCheckbox: (e: any, evaluationQuestionID: number) => void;
  handleChangeAnswers: (e: any, evaluationQuestionID: number) => void;
  handleChangeSelectEvaluation: (
    e: any,
    optionID: number,
    evaluationQuestionID: number
  ) => void;
}

export const QuestionOptions: React.FC<QuestionOptionsProps> = ({
  question,
  handleChangeCheckbox,
  handleChangeAnswers,
  handleChangeSelectEvaluation,
}) => {
  return (
    <>
      {
        {
          1: JSON.parse(question.options).map((option: any) => {
            return (
              <Checkbox
                key={option.OptionID}
                id={"checkbox" + option.OptionID}
                label={option.Option}
                onClick={(e) =>
                  handleChangeCheckbox(e, question.evaluationQuestionID)
                }
              />
            );
          }),

          2: (
            <RadioButtons
              alignment="vertical"
              name={"radio" + question.evaluationQuestionID}
              value={question.answerSelected}
            >
              {JSON.parse(question.options).map((option: any) => {
                return (
                  <RadioButton
                    key={option.OptionID}
                    id={"radio" + option.OptionID}
                    value={"option" + option.OptionID}
                    label={option.Option}
                    onClick={(e) =>
                      handleChangeAnswers(e, question.evaluationQuestionID)
                    }
                  />
                );
              })}
            </RadioButtons>
          ),

          3: JSON.parse(question.options)
            .filter((item: { Column: number }) => item.Column === 2)
            .map((option: any, index: number) => {
              return (
                <Select
                  key={"select" + index}
                  className="modalEvaluationSelect"
                  label={option.Option}
                  onChange={(e) =>
                    handleChangeSelectEvaluation(
                      e,
                      option.OptionID,
                      question.evaluationQuestionID
                    )
                  }
                  options={JSON.parse(question.options)
                    .filter((item: { Column: number }) => item.Column === 1)
                    .map((option: any) => {
                      return {
                        value: option.OptionID,
                        label: option.Option,
                      };
                    })}
                  placement="bottom-start"
                />
              );
            }),

          4: (
            <RadioButtons
              alignment="vertical"
              name={"radio" + question.evaluationQuestionID}
              value={question.answerSelected}
            >
              {JSON.parse(question.options).map((option: any) => {
                return (
                  <RadioButton
                    key={option.OptionID}
                    id={"radio" + option.OptionID}
                    value={"option" + option.OptionID}
                    label={option.Option}
                    onClick={(e) =>
                      handleChangeAnswers(e, question.evaluationQuestionID)
                    }
                  />
                );
              })}
            </RadioButtons>
          ),
        }[question.questionTypeID as 1 | 2 | 3 | 4]
      }
    </>
  );
};
